import { useAppConfig } from "@/appConfig";

// Premium-only on every tenant, Gitcha included. Callers must pass a real
// isAgentPremium; there is no site-wide bypass any more.
const ProBadge = ({ isAgentPremium = false, className = "pro-tag" }) => {
  const { flags } = useAppConfig();

  if (!flags.proBadge) return null;
  if (!isAgentPremium) return null;

  return <span className={className}>PRO</span>;
};

export default ProBadge;
